export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档热门动作大片合集',
    desc: '集结年度最强动作巨制，肾上腺素全程飙升的高燃观影体验',
    tag: '专题推荐',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20action%20scene%20with%20dramatic%20warm%20lighting%2C%20heroic%20silhouette%20against%20fiery%20sunset%20sky%2C%20golden%20and%20crimson%20tones%2C%20film%20grain%20texture%2C%20atmospheric%20movie%20poster%20aesthetic%2C%20stylized%20cinematic%20art%2C%20widescreen%20composition%2C%20dramatic%20cloud%20formations%2C%20epic%20scale%2C%20artistic%20rendering%2C%20rich%20contrast&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高口碑悬疑烧脑剧集精选',
    desc: '层层反转、伏笔精妙，国产高分悬疑剧一网打尽',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20atmosphere%20urban%20night%20scene%20with%20warm%20amber%20streetlights%2C%20deep%20shadows%20and%20golden%20highlights%2C%20film%20noir%20aesthetic%2C%20artistic%20cinematic%20composition%2C%20stylized%20urban%20landscape%2C%20moody%20and%20elegant%2C%20sophisticated%20color%20palette%2C%20vintage%20cinema%20texture&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '高分治愈系文艺片专场',
    desc: '用光影温暖心灵，那些值得反复品味的独立佳作',
    tag: '品质推荐',
    image: 'https://readdy.ai/api/search-image?query=Serene%20natural%20landscape%20with%20golden%20hour%20lighting%20through%20trees%2C%20warm%20earth%20tones%20with%20soft%20cinematic%20color%20grading%2C%20peaceful%20contemplative%20mood%2C%20artistic%20photography%20aesthetic%2C%20gentle%20atmospheric%20haze%2C%20stylized%20pastoral%20scene%2C%20rich%20warm%20greens%20and%20amber%20tones&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '经典港片修复重映季',
    desc: '重温黄金年代的银幕传奇，高清修复画质焕然一新',
    tag: '经典回眸',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20with%20neon%20signs%20reflecting%20on%20wet%20streets%2C%20warm%20vintage%20color%20tones%2C%20nostalgic%20cinematic%20aesthetic%2C%20film%20grain%20overlay%2C%201980s%20urban%20atmosphere%2C%20rich%20golden%20and%20amber%20lighting%2C%20stylized%20retro%20composition%2C%20dramatic%20shadows&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '热门国漫IP全系列追番指南',
    desc: '从热血修仙到玄幻异世，国漫崛起必看神作列表',
    tag: '追番必备',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20fantasy%20landscape%20with%20floating%20mountains%2C%20ethereal%20mist%20and%20golden%20light%20rays%2C%20traditional%20eastern%20aesthetic%20with%20modern%20cinematic%20treatment%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20artistic%20composition%2C%20atmospheric%20depth&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '全球纪录片精品馆',
    desc: '探索未知世界的真实魅力，BBC与Netflix高分纪录片全收录',
    tag: '知识盛宴',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20style%20cinematic%20aerial%20landscape%20with%20dramatic%20natural%20scenery%2C%20warm%20golden%20sunlight%20over%20vast%20wilderness%2C%20atmospheric%20haze%2C%20rich%20earth%20tones%20and%20deep%20greens%2C%20epic%20scale%20composition%2C%20stylized%20nature%20cinematography%2C%20professional%20color%20grading&width=800&height=450&seq=carousel-06&orientation=landscape',
  },
];

export const updateItems = [
  { date: '07-31', title: '《长安十二时辰》导演剪辑版全集上线', tag: '热播', tagColor: 'primary' },
  { date: '07-30', title: '2026年暑期档票房冠军《龙战》高清版已更新', tag: '新片', tagColor: 'accent' },
  { date: '07-29', title: '豆瓣9.2分神作《深海回响》4K修复版独家放送', tag: '高分', tagColor: 'primary' },
  { date: '07-28', title: '《异人之下》动画第三季正式开播同步更新', tag: '连载', tagColor: 'accent' },
  { date: '07-27', title: 'Netflix热门韩剧《黑暗荣耀》中文配音版上线', tag: '引进', tagColor: 'primary' },
  { date: '07-26', title: '《流浪地球3》先行概念短片独家曝光', tag: '独家', tagColor: 'accent' },
  { date: '07-25', title: '国漫之光《凡人修仙传》第五季定档预告发布', tag: '定档', tagColor: 'primary' },
  { date: '07-24', title: '《我不是药神》导演新作《向阳而生》全网首播', tag: '首播', tagColor: 'accent' },
  { date: '07-23', title: '暑期特供：100部经典港片修复版限时免费观看', tag: '福利', tagColor: 'primary' },
];

export const cardItems = [
  {
    id: 1,
    title: '电影大片',
    desc: '院线新片、经典老片、文艺独立电影，海量片库每日更新',
    icon: 'ri-movie-2-line',
    count: '18,000+',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20theater%20interior%20with%20warm%20golden%20spotlight%2C%20velvet%20red%20seats%2C%20elegant%20art%20deco%20decorative%20elements%2C%20atmospheric%20movie%20watching%20environment%2C%20rich%20dark%20crimson%20and%20gold%20color%20palette%2C%20stylized%20artistic%20rendering%2C%20sophisticated%20luxury%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热播剧集',
    desc: '国产剧、韩剧、美剧、日剧全覆盖，追剧不等待',
    icon: 'ri-tv-2-line',
    count: '22,000+',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20large%20screen%20displaying%20warm%20cinematic%20visuals%2C%20soft%20ambient%20lighting%2C%20comfortable%20atmosphere%2C%20rich%20amber%20and%20cream%20tones%2C%20modern%20home%20theater%20aesthetic%2C%20stylized%20interior%20design%2C%20inviting%20warmth&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺娱乐',
    desc: '热门综艺、脱口秀、真人秀，笑料不断精彩不停',
    icon: 'ri-emotion-laugh-line',
    count: '5,600+',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20studio%20stage%20with%20warm%20spotlights%20and%20colorful%20decor%2C%20entertainment%20show%20atmosphere%2C%20cheerful%20and%20energetic%20mood%2C%20golden%20and%20coral%20lighting%2C%20stylized%20performance%20venue%2C%20artistic%20composition%2C%20dynamic%20stage%20design&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '动漫番剧',
    desc: '国漫日漫、新番旧番，二次元世界一触即达',
    icon: 'ri-ghost-line',
    count: '12,500+',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20cityscape%20with%20cherry%20blossoms%20and%20warm%20sunset%20colors%2C%20traditional%20eastern%20architecture%20blended%20with%20modern%20elements%2C%20soft%20pink%20and%20golden%20tones%2C%20dreamy%20atmospheric%20haze%2C%20stylized%20animated%20aesthetic%2C%20artistic%20composition&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片',
    desc: '自然、历史、科技、人文，用镜头探索世界',
    icon: 'ri-earth-line',
    count: '3,200+',
    image: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20vast%20natural%20landscape%20with%20dramatic%20sunlight%2C%20mountain%20ranges%20and%20winding%20rivers%2C%20warm%20earth%20tones%2C%20documentary%20cinematography%20style%2C%20epic%20scale%2C%20atmospheric%20depth%2C%20rich%20greens%20and%20golden%20light&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '少儿天地',
    desc: '精选优质动画、教育节目，陪伴孩子快乐成长',
    icon: 'ri-heart-line',
    count: '4,800+',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20childrens%20playroom%20with%20soft%20warm%20lighting%2C%20creative%20toys%20and%20books%2C%20cheerful%20atmosphere%2C%20pastel%20warm%20tones%20of%20coral%20and%20cream%2C%20cozy%20and%20inviting%20environment%2C%20stylized%20interior%20design%2C%20gentle%20composition&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export const indexItems = [
  { id: 1, title: '动作冒险', desc: '高能打斗、极速追逐，肾上腺素飙升的观影体验', icon: 'ri-sword-line', count: 3200 },
  { id: 2, title: '喜剧搞笑', desc: '轻松一刻，笑料不断，治愈所有不开心', icon: 'ri-emotion-happy-line', count: 2800 },
  { id: 3, title: '爱情浪漫', desc: '甜虐交织，心动故事，感受爱的千百种模样', icon: 'ri-heart-pulse-line', count: 2100 },
  { id: 4, title: '科幻奇幻', desc: '未来世界，异想时空，脑洞大开的视觉盛宴', icon: 'ri-rocket-line', count: 1800 },
  { id: 5, title: '恐怖惊悚', desc: '心跳加速，细思极恐，深夜慎入的刺激体验', icon: 'ri-ghost-smile-line', count: 950 },
  { id: 6, title: '犯罪悬疑', desc: '层层推理，反转不断，考验智商的烧脑之旅', icon: 'ri-search-eye-line', count: 1600 },
  { id: 7, title: '战争历史', desc: '宏大叙事，史诗还原，铭记那些不该被遗忘的时刻', icon: 'ri-ancient-gate-line', count: 720 },
  { id: 8, title: '武侠古装', desc: '江湖快意，侠骨柔情，东方美学的极致展现', icon: 'ri-leaf-line', count: 1400 },
  { id: 9, title: '家庭伦理', desc: '家长里短，人间烟火，平凡生活里的大智慧', icon: 'ri-home-heart-line', count: 1100 },
];

export const rankingItems = [
  { rank: 1, title: '龙战', subtitle: '2026暑期档票房冠军·动作科幻', score: 9.1, hot: '🔥 320万热度', tag: '新' },
  { rank: 2, title: '深海回响', subtitle: '4K修复版·豆瓣9.2分文艺神作', score: 9.2, hot: '286万热度', tag: '荐' },
  { rank: 3, title: '长安十二时辰', subtitle: '导演剪辑版·古装悬疑巅峰', score: 8.9, hot: '253万热度', tag: '热' },
  { rank: 4, title: '向阳而生', subtitle: '徐峥新作·现实主义催泪力作', score: 8.7, hot: '218万热度', tag: '新' },
  { rank: 5, title: '异人之下 第三季', subtitle: '国漫顶流回归·超能力热血番', score: 8.8, hot: '195万热度', tag: '追' },
  { rank: 6, title: '黑暗荣耀', subtitle: 'Netflix现象级韩剧·中文配音版', score: 9.0, hot: '172万热度', tag: '热' },
  { rank: 7, title: '凡人修仙传 第五季', subtitle: '国漫之光·定档预告引爆期待', score: 8.6, hot: '158万热度', tag: '待' },
];

export const featureItems = [
  {
    id: 1,
    title: '极速播放 高清不缓冲',
    desc: '全网CDN加速节点覆盖，1080P超清画质秒加载，告别卡顿等待，观影如丝般顺滑。支持4K HDR超高清片源，即使在网络波动时也能智能切换画质，保证播放连续性。',
    icon: 'ri-speed-up-line',
  },
  {
    id: 2,
    title: '海量片库 每日更新',
    desc: '收录超过六万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片全品类。专业编辑团队每日精选推荐，热门新片上线即时同步，让你永远走在追剧第一线。',
    icon: 'ri-database-2-line',
  },
  {
    id: 3,
    title: '纯净观影 免费观看',
    desc: '全站资源免费开放，无需注册即可畅享高清观影体验。严格过滤低质量片源，每部作品均经过画质检测，承诺无强制广告弹窗，打造清爽纯粹的观影环境。',
    icon: 'ri-shield-check-line',
  },
];

export const appItem = {
  title: '777影院移动端',
  desc: '随时随地，高清相伴。777影院移动端适配手机和平板，支持画中画、离线缓存、投屏播放。无论通勤路上还是睡前时光，打开即享沉浸式观影体验。',
  features: ['画中画播放', '智能投屏', '离线缓存', '夜间模式', '多端同步'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20cinematic%20movie%20interface%20with%20warm%20dark%20theme%2C%20elegant%20mobile%20app%20design%2C%20golden%20accent%20elements%20on%20screen%2C%20premium%20device%20mockup%2C%20soft%20ambient%20lighting%2C%20dark%20crimson%20and%20gold%20color%20scheme%2C%20minimalist%20product%20photography%2C%20sophisticated%20presentation&width=500&height=700&seq=app-01&orientation=portrait',
};

export const commentItems = [
  {
    id: 1,
    name: '电影发烧友老王',
    avatar: 'ri-user-3-line',
    time: '2天前',
    content: '用了半年了，片源更新速度是真的快，电影院刚下映的片子这里就能看了。画质也没得说，4K投屏到电视上跟蓝光碟一样清楚。推荐给身边好多朋友了！',
    likes: 128,
  },
  {
    id: 2,
    name: '追剧小达人',
    avatar: 'ri-user-heart-line',
    time: '3天前',
    content: '韩剧更新的速度比我想象中快太多了！《黑暗荣耀》中文配音版一上线就有，再也不用到处找资源了。而且播起来一点都不卡，太丝滑了。',
    likes: 96,
  },
  {
    id: 3,
    name: '动漫迷阿杰',
    avatar: 'ri-user-smile-line',
    time: '5天前',
    content: '国漫区真的太良心了，从老番到新番基本上是全网最全的。《异人之下》第三季每周同步更新，画质稳定1080P，弹幕氛围也很友好。',
    likes: 75,
  },
  {
    id: 4,
    name: '周末观影人',
    avatar: 'ri-user-star-line',
    time: '6天前',
    content: '最让我惊喜的是纪录片频道，BBC的《地球脉动》系列全都有高清版。周末泡杯茶窝在沙发里看纪录片，成了我每周最期待的时光。',
    likes: 53,
  },
];

export const topicItems = [
  { id: 1, name: '暑期档', count: '2.8万讨论' },
  { id: 2, name: '国漫崛起', count: '2.3万讨论' },
  { id: 3, name: '4K修复', count: '1.9万讨论' },
  { id: 4, name: '悬疑烧脑', count: '1.7万讨论' },
  { id: 5, name: '豆瓣高分', count: '1.6万讨论' },
  { id: 6, name: '徐峥新片', count: '1.4万讨论' },
  { id: 7, name: 'Netflix引进', count: '1.3万讨论' },
  { id: 8, name: '经典港片', count: '1.2万讨论' },
  { id: 9, name: '韩剧热播', count: '1.1万讨论' },
  { id: 10, name: '动画电影', count: '9,800讨论' },
  { id: 11, name: '纪录片推荐', count: '8,500讨论' },
];

export const mediaItems = [
  {
    id: 1,
    title: '《龙战》终极预告 · 4K杜比视界',
    duration: '03:28',
    views: '189万次播放',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20action%20scene%20with%20dragon%20silhouette%20against%20fiery%20orange%20sky%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20golden%20and%20crimson%20tones%2C%20stylized%20movie%20trailer%20thumbnail%20aesthetic%2C%20bold%20contrast%2C%20professional%20color%20grading&width=700&height=400&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《深海回响》导演深度访谈',
    duration: '15:42',
    views: '76万次播放',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20interview%20setting%20with%20warm%20golden%20key%20light%2C%20film%20director%20atmosphere%2C%20cinematic%20behind%20the%20scenes%20aesthetic%2C%20soft%20amber%20and%20cream%20tones%2C%20professional%20video%20thumbnail%20style%2C%20artistic%20composition%2C%20elegant%20mood&width=700&height=400&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫崛起之路 · 从大圣到哪吒',
    duration: '22:15',
    views: '134万次播放',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20character%20art%20showcase%20with%20traditional%20ink%20wash%20style%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20modern%20CG%20blended%20with%20classical%20eastern%20aesthetic%2C%20artistic%20composition%2C%20cinematic%20lighting%2C%20stylized%20thumbnail%20design&width=700&height=400&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《异人之下》配音幕后花絮',
    duration: '08:56',
    views: '92万次播放',
    image: 'https://readdy.ai/api/search-image?query=Voice%20recording%20studio%20with%20warm%20ambient%20lighting%2C%20microphone%20and%20script%20on%20desk%2C%20creative%20workspace%20atmosphere%2C%20golden%20and%20soft%20amber%20tones%2C%20professional%20audio%20production%20environment%2C%20stylized%20behind%20the%20scenes%20aesthetic%2C%20cozy%20mood&width=700&height=400&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '十大必看悬疑片 · 烧脑精选',
    duration: '12:30',
    views: '205万次播放',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20collage%20with%20warm%20shadowy%20atmosphere%2C%20film%20noir%20elements%2C%20golden%20and%20deep%20amber%20lighting%2C%20detective%20theme%20aesthetic%2C%20stylized%20video%20essay%20thumbnail%2C%20dramatic%20contrast%2C%20elegant%20composition&width=700&height=400&seq=media-05&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 1,
    q: '777影院需要注册才能观看吗？',
    a: '不需要！777影院午夜伦不卡全站资源免费开放，无需注册登录即可直接在线观看。我们坚持纯净观影体验，让每位影迷都能零门槛享受高清影视内容。',
  },
  {
    id: 2,
    q: '视频播放卡顿怎么办？',
    a: '777影院采用全网CDN加速技术，在全国范围内部署了数百个加速节点。如果遇到卡顿，可以尝试切换画质（从4K降至1080P），或检查本地网络环境。绝大多数用户反馈播放流畅。',
  },
  {
    id: 3,
    q: '支持哪些设备观看？',
    a: '777影院全面兼容PC、平板和手机端。电脑浏览器直接访问即可，手机和平板同样适配完美。还支持DLNA投屏功能，可将内容投射到智能电视上享受大屏观影。',
  },
  {
    id: 4,
    q: '片源更新频率如何？',
    a: '每日定时更新，热门新片通常在首映后48小时内上线，热门剧集会同步追更。我们有一支专业的编辑团队负责片源筛选和更新维护，确保内容的时效性和画质水平。',
  },
  {
    id: 5,
    q: '777影院安全吗？会有病毒吗？',
    a: '777影院承诺无强制弹窗广告和恶意软件。我们采用HTTPS加密传输保障您的浏览安全，服务器经过严格安全加固。请认准官方域名访问，谨防山寨站点。',
  },
  {
    id: 6,
    q: '如何获取最新上架通知？',
    a: '您可以通过关注我们的官方社交媒体账号获取每日更新推送。也可以通过主题索引和更新快讯模块随时了解最新上线内容。热门新片上线会有首页置顶推荐。',
  },
];